export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M4 17v.5H3v1h1v.5H2v1h3v-4H2v1zm0-9V4H2v1h1v3zm-.2 3L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zM7 7h14V5H7zm14 12v-2H7v2zm0-6v-2H7v2z\"/>"
};